import { FB_Template } from "@algomusinc/domain";
import { getNumberValue } from "./getNumberValue";

export const calcForecastMeasuresRDP = (
    key: string,
    gridListUI: Array<any>,
    parentKey: string,
    mivIndex?: number,
    fbTemplateId?: number | any,
    fbForecastMIVResponseModelKey?: string
  ): any => {
  if([FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner].includes(fbTemplateId)){
    return calcForecastMeasuresRDPMulti(
      key,
      gridListUI,
      parentKey,
      mivIndex,
      fbTemplateId,
      fbForecastMIVResponseModelKey,
    )
  }else{
    let RDPTotalForecast;
    let timeframeColumn = gridListUI.find((row) => row.title === key);
    if(timeframeColumn && timeframeColumn[parentKey]){
      const RDPManualFcstAdjustmentPct = timeframeColumn[parentKey]['RDPManualFcstAdjustmentPct'] || 0;
      const RDPPromoFcstAdjustmentPct = timeframeColumn[parentKey]['RDPPromoFcstAdjustmentPct'] || 0;
      if (
        RDPManualFcstAdjustmentPct !== 'Multiple %' &&
        RDPPromoFcstAdjustmentPct !== 'Multiple %'
        ) {
        const RDPBaselineFcst = timeframeColumn[parentKey]['RDPBaselineFcst'];
        let RDPManualFcstAdjustment = timeframeColumn[parentKey]['RDPManualFcstAdjustment'];
        let RDPBaselineAttachRateQuantity = timeframeColumn[parentKey]['RDPBaselineAttachRateQuantity'];
        let RDPPromoUnits = timeframeColumn[parentKey]['RDPPromoUnits'];
        if (RDPBaselineFcst == 0) {
          RDPManualFcstAdjustment = 0;
          RDPPromoUnits = 0;
        }
        const pctManualValue = RDPManualFcstAdjustmentPct / 100;
        const pctPromoValue = RDPPromoFcstAdjustmentPct / 100;
        RDPTotalForecast = Math.round(
          (getNumberValue(RDPBaselineFcst) +
            getNumberValue(RDPManualFcstAdjustment) +
            getNumberValue(RDPBaselineAttachRateQuantity) +
            getNumberValue(RDPPromoUnits) * (1 + pctPromoValue)) *
            (1 + pctManualValue)
        );
      }
    }
    return RDPTotalForecast;
  }
};
function calcForecastMeasuresRDPMulti(
  key: string,
  gridListUI: Array<any>,
  parentKey: string,
  mivIndex: any,
  fbTemplateId: any,
  fbForecastMIVResponseModelKey: any
) {
  let RDPTotalForecast;
  let timeframeColumn = gridListUI.find((row) => row.title === key);
  if(timeframeColumn && timeframeColumn[fbForecastMIVResponseModelKey] && timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]){
    const RDPManualFcstAdjustmentPct = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['RDPManualFcstAdjustmentPct'] || 0;
    const RDPPromoFcstAdjustmentPct = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['RDPPromoFcstAdjustmentPct'] || 0;
    if (
      RDPManualFcstAdjustmentPct !== 'Multiple %' &&
      RDPPromoFcstAdjustmentPct !== 'Multiple %'
      ) {
      const RDPBaselineFcst = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['RDPBaselineFcst'];
      let RDPManualFcstAdjustment = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['RDPManualFcstAdjustment'];
      let RDPBaselineAttachRateQuantity = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['RDPBaselineAttachRateQuantity'];
      let RDPPromoUnits = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['RDPPromoUnits'];
      if (RDPBaselineFcst == 0) {
        RDPManualFcstAdjustment = 0;
        RDPPromoUnits = 0;
      }
      const pctManualValue = RDPManualFcstAdjustmentPct / 100;
      const pctPromoValue = RDPPromoFcstAdjustmentPct / 100;
      RDPTotalForecast = Math.round(
        (getNumberValue(RDPBaselineFcst) +
          getNumberValue(RDPManualFcstAdjustment) +
          getNumberValue(RDPBaselineAttachRateQuantity) +
          getNumberValue(RDPPromoUnits) * (1 + pctPromoValue)) *
          (1 + pctManualValue)
      );
    }
  }
  return RDPTotalForecast;
}
